import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";
import { Provider } from "react-redux";
import PreBootContainer from "./PreBootContainer";
import ReduxIntlProvider from "../i18n/ReduxIntlProvider";
import Routes from "./Routes";

const ClientApp = withRouter(Routes);

const PreBootApp = () => (
  <ReduxIntlProvider
    onError={error => {
      console.log(error)
    }}
  >
    <PreBootContainer>
      <ClientApp />
    </PreBootContainer>
  </ReduxIntlProvider>
);

const Main = ({ store }) => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route component={PreBootApp} />
      </Switch>
    </Router>
  </Provider>
);

Main.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Main;



// WEBPACK FOOTER //
// ./components/Main.jsx